var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoreButton',{on:{"click":_vm.logout}},[_c('Icon',{staticClass:"sm:mr-2",attrs:{"icon":"mdi-logout"}}),_c('span',{staticClass:"hidden sm:inline-block"},[_vm._v("Выйти")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }